<template>
  <div v-if="products != null">
    <section class="text_center">
      <p>ポイントは下記の方法で追加頂けます。</p>
    </section>
    <section class="point_purchase_list no_padding">
      <ul class="pl-0">
        <li v-for="(item, index) in products" :key="index">
          <router-link :to="item.payment_way === 'credit_wc' ? { name: item.name, params: { paymentWay: item.payment_way } } : { name: item.name }" class="menu_list_font--text">{{ item.label }}</router-link>
        </li>
      </ul>
    </section>
    <section>
      <div class="notice">
        <p>サービスの性質上、商品引き渡し後(ポイント追加後)の返金に応じる事はできません。</p>
      </div>
      <div class="notice">
        <p>
          アドレス登録がお済みでない会員様はメールでの決済完了通知が届きませんので、ポイントの追加に関してはTOPページにてご確認下さい。<br>
          アドレス登録をして頂く事で決済完了通知が届きますので、ご希望の際は<router-link :to="{ name: 'UserMailChange' }" class="link_main--text text-decoration-underline">▼コチラ▼</router-link>よりご登録下さい。
        </p>
      </div>
      <p v-if="unsupportedProducts != ''" class="unsupported">
        {{ unsupportedProducts }}は公開へ向けて準備中です。公開までもうしばらくお待ち下さい。
      </p>
    </section>
    <section class="support">
      <p>鑑定ポイント購入方法でご不明な点が御座いましたらお気軽に{{ info.title }}サポートセンターまでご連絡下さい。</p>
      <p class="text_center">{{ info.title }}サポートセンター</p>
      <router-link :to="{ name: 'PageFixed', params: { code: 'contact_us' } }" class="btn arrow">お問い合わせ</router-link>
    </section>
  </div>
</template>

<script>
import { GET_PRODUCT_LIST } from '@/store/point/actions'
import { PRODUCTS } from '@/helper/constant'

export default {
  name: 'PointPurchaseList',
  props: {
    info: Object
  },
  data () {
    return {
      products: []
    }
  },
  computed: {
    unsupportedProducts () {
      const myProducts = this.products.filter(g => g.is_active === false)
      if (myProducts.length > 0) {
        const self = this
        return myProducts.map(row => {
          const label = self.productLabel(row.payment_way)
          return [label]
        })
          .reduce(function (a, b) {
            return a.concat(b)
          })
          .filter(g => g !== '')
          .join('、')
      } else {
        return ''
      }
    }
  },
  methods: {
    getProducts () {
      this.$store.dispatch(GET_PRODUCT_LIST)
        .then((data) => {
          const paymentWayMap = {
            bank: 'PointBank',
            bank_anotherlane: 'PointBankAnotherlaneForm',
            bank_telecom: 'PointBankTelecomForm',
            credit_wc: 'PointCreditForm',
            bitcash: 'PointBitcashForm',
            netridecash: 'PointNetridecashForm',
            netridecash_tc: 'PointNetridecashTechcoinForm',
            securitymoney: 'PointSecuritymoneyForm',
            credit_telecom: 'PointCreditTelecomForm',
            gmoney: 'PointGmoneyForm',
            credit_tc: 'PointCreditTechcoinForm',
            gpay: 'PointGpayForm'
          }
          this.products = data.products.map(product => {
            return {
              ...product,
              name: paymentWayMap[product.payment_way] || ''
            }
          })
        })
        .catch(() => {})
    },
    isInPreparation (paymentWay) {
      const product = this.products.find(g => g.payment_way === paymentWay)
      return (product != null) ? !product.is_active : true
    },
    productLabel (paymentWay) {
      const product = PRODUCTS.find(g => g.value === paymentWay)
      return (product != null) ? product.label : ''
    }
  },
  created () {
    this.getProducts()
  }
}
</script>
